import { replaceObjectInNestedArray } from '../../../helpers/functions/functions';
import { FETCH_SURVEYS, FETCH_SURVEY_FORM, SET_SURVEY, UPDATE_QUESTION, CLEAR_SURVEY, CLEAR_SURVEYS, SET_QUESTION_ANSWER } from '../actions/types';
import { CLEAR_REDUCER } from '../../Login/actions/types';

const surveyInitialState = {
	id: null,
	name: '',
	completed: '0',
	questions: [],
	survey_id: null,
	users_id: null,
};

const initialState = {
	fields: [],
	data: [],
	total_count: null,
	items: [],
	current: 1,
	first: 1,
	last: 1,
	limit: 10,
	next: 1,
	previous: 1,
	total_items: 0,
	survey: surveyInitialState,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_SURVEYS:
			return {
				...state,
				fields: action.payload.fields,
				items: action.payload.data,
				total_count: action.payload.total_count,
			};
		case FETCH_SURVEY_FORM:
			return {
				...state,
				survey: { ...state.survey, ...action.payload },
				//fields: action.payload.fields,
				//items: action.payload.data,
				//total_count: action.payload.total_count,
			};
		case SET_SURVEY:
			return {
				...state,
				survey: { ...state.survey, ...action.payload },
			};
		case UPDATE_QUESTION:
			let auxQuestions = replaceObjectInNestedArray({
				arr: [...state.questions],
				key: 'id',
				value: action.payload.question_id,
				replacement: action.payload.data,
			});

			return {
				...state,
				survey: { ...state.survey, ...{ questions: auxQuestions } },
			};
		case SET_QUESTION_ANSWER:
			return {
				...state,
				survey: {
					...state.survey,
					questions: state.survey.questions.map((question) =>
						action.payload.question_id == question.id ? { ...question, answer: action.payload.answer } : question
					),
				},
			};
		case CLEAR_SURVEY:
			return {
				...state,
				survey: surveyInitialState,
			};
		case CLEAR_SURVEYS:
			return {
				...initialState,
				survey: state.survey,
			};
		case CLEAR_REDUCER:
			return {
				...initialState,
			};
		default:
			return state;
	}
}
